import { USDSymbol, AEDSymbol, IQDSymbol } from "./currencySymbols";

export const DEFAULT_CURRENCY = "USD";

export const BASE_CURRENCIES = {
  USD: {
    code: "USD",
    name: "US Dollar",
    symbol: USDSymbol,
    decimalPlaces: 2,
  },
  AED: {
    code: "AED",
    name: "UAE Dirham",
    symbol: AEDSymbol,
    decimalPlaces: 2,
  },
  IQD: {
    code: "IQD",
    name: "Iraqi Dinar",
    symbol: IQDSymbol,
    decimalPlaces: 0,
  },
};
